import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useForm } from "react-hook-form";
import {
  SelectFormm,
  TextAreaForm,
} from "../../components/molecules/forms/index";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import DetailDataSkeleton from "../../components/template/skeleton/DetailDataSkeleton";
import Swal from "sweetalert2";
import {
  useCreateSignMutation,
  useKeyListSignMutation,
} from "../../store/feature/service/wsop";
import sign from "../../utils/validation/sign";

const Sign = () => {
  // REGION: INIT VARIABLES
  const location = useLocation();
  const { pathname } = location;
  const [optKey, setOptKey] = useState([]);
  const editFgroup = pathname.includes("edit");

  const [keyListSign, { isSuccess, isError, data, error }] =
    useKeyListSignMutation();
  const [
    createSign,
    {
      isSuccess: successSign,
      isError: errorSign,
      data: dataSign,
      error: dataErrorSign,
      isLoading: loadingSign
    },
  ] = useCreateSignMutation();

  const optAlgo = [
    {
      label: "RS256",
      value: "RS256",
    },
    {
      label: "RS384",
      value: "RS384",
    },
    {
      label: "RS512",
      value: "RS512",
    },
    {
      label: "PS256",
      value: "PS256",
    },
    {
      label: "PS384",
      value: "PS384",
    },
    {
      label: "PS512",
      value: "PS512",
    },
    {
      label: "HS256",
      value: "HS256",
    },
    {
      label: "HS384",
      value: "HS384",
    },
    {
      label: "HS512",
      value: "HS512",
    },
    {
      label: "ES256",
      value: "ES256",
    },
    {
      label: "ES384",
      value: "ES384",
    },
    {
      label: "ES512",
      value: "ES512",
    },
    {
      label: "ECDSA-SHA256",
      value: "ECDSA-SHA256",
    },
    {
      label: "ECDSA-SHA384",
      value: "ECDSA-SHA384",
    },
    {
      label: "ECDSA-SHA512",
      value: "ECDSA-SHA512",
    },
  ];

  // const { data: dataMaskPolicy } = useGetMaskPolicyDetailQuery(idParam);
  // REGION: INIT FORM DATA
  const {
    control,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<{
    key: string;
    algorithm: string;
    inputVal: string;
    result: string;
  }>({
    reValidateMode: "onChange",
    resolver: yupResolver(sign),
    defaultValues: {
      key: "",
      algorithm: "",
      inputVal: "",
      result: "",
    },
  });

  // REGION: SET FORM DATA
  useEffect(() => {
    if (data) {
      setOptKey(
        data.map((item: any) => ({
          label: item.sworldIdent,
          value: item.kid,
        }))
      );
    }
  }, [data]);

  // REGION: DISPATCH SUCCESS EVENT
  useEffect(() => {
    keyListSign({});
  }, []);

  useEffect(()=> {
    if(dataSign){
      setValue("result",dataSign?.signature)
    }
  }, [dataSign])

  // REGION: DISPATCH INSERT & UPDATE DATA
  const onSubmit = (e: any) => {
    let tempVar = {
      kid: e.key,
      alg: e.algorithm,
      payload: e.inputVal,
    };
    createSign(tempVar);
  };

  useEffect(() => {
    if (errorSign) {
      const dataError: any = dataErrorSign;
      // console.log('wkwkwk ===> ', dataErrorSign?.data)
      Swal.fire({
        icon: "error",
        title: "Error Create",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: dataError?.data?.error,
      });
    }
  }, [errorSign]);

  // useEffect(() => {
  //   if (successSign) {
  //     Swal.fire({
  //       icon: "success",
  //       title: "Success Sign",
  //       showCancelButton: false,
  //       confirmButtonText: "OK",
  //       confirmButtonColor: "#051438",
  //       text: "Success Sign Key",
  //     }).then(() => navigate("/masking-policy"));
  //   }
  // }, [successSign]);
  // REGION: RETURN TSX
  return (
    <DetailDataSkeleton
      isLoading={false}
      isLoadingEvent={loadingSign}
      inputCount={6}
      titleWidth={"350px"}
    >
      <Box component="form" onSubmit={handleSubmit(onSubmit)} paddingY="20px">
        <Typography variant="h3" fontFamily="Open Sans" mb={3}>
          Sign
        </Typography>
        <SelectFormm
          name="key"
          label="Key"
          defaultValue={0}
          options={optKey}
          placeholder="Please Select"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          required
        />
        <SelectFormm
          name="algorithm"
          label="Algorithm"
          defaultValue={0}
          options={optAlgo}
          placeholder="Please Select"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          required
        />
        <TextAreaForm
          name="inputVal"
          label="Input Value"
          placeholder="Type Input Value"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          maxLength={1000}
          required
          defaultValue={""}
        />

        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
        >
          <Button variant="contained" type="submit">
            Sign
          </Button>
        </Stack>

        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          Result
        </Typography>
        <TextAreaForm
          name="result"
          placeholder="Type Input Value"
          disabled={editFgroup}
          isLoading={false}
          control={control}
          errors={errors}
          maxLength={1000}
          required
          defaultValue={""}
        />
      </Box>
    </DetailDataSkeleton>
  );
};

export default Sign;
